import React, { useEffect, useState } from "react";
import { Search, X } from "lucide-react";
import { Input } from "@/components/ui/input";

export const SearchBox = ({ onSearch, placeholder = "Search…", testId = "search-input" }) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    const t = setTimeout(() => onSearch(value.trim()), 300);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);
  return (
    <div className="relative w-full sm:w-72">
      <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground pointer-events-none" />
      <Input data-testid={testId} value={value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder} className="pl-9 pr-8 bg-white" />
      {value && (
        <button type="button" data-testid={`${testId}-clear`} onClick={() => setValue("")} className="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground">
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  );
};
